export default __webpack_public_path__ + "static/media/profile-setting.380a241e.svg";